var React = require('react');

function LessIcon (props) {
    return React.createElement("svg",props,React.createElement("path",{"fillRule":"evenodd","clipRule":"evenodd","d":"M6 53.1429C6 48.6457 9.76769 45 14.4146 45H112.585C117.232 45 121 48.6457 121 53.1429V74.8571C121 79.3543 117.232 83 112.585 83H14.4146C9.76769 83 6 79.3543 6 74.8571V53.1429ZM14.4146 50.4286H112.585C114.134 50.4286 115.39 51.6437 115.39 53.1429V74.8571C115.39 76.3563 114.134 77.5714 112.585 77.5714H14.4146C12.8657 77.5714 11.6098 76.3563 11.6098 74.8571V53.1429C11.6098 51.6437 12.8657 50.4286 14.4146 50.4286Z","fill":"#333333"}));
}

LessIcon.defaultProps = {"width":"128","height":"128","viewBox":"0 0 128 128","fill":"none"};

module.exports = LessIcon;

LessIcon.default = LessIcon;
